module.exports = __webpack_public_path__ + "static/desktop/img/american-express-curved-128px.b67c47bd.png";